import Meta from '@/components/common/Meta'

import PersonalStorageOptionsPage from '@/v2/components/pages/landing-pages/personal-storage-options-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/personal-storage-options-page'

interface PersonalStorageOptionsPageProps {}

const Page: React.FC<PersonalStorageOptionsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.personal_storage_options.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.personal_storage_options?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.personal_storage_options?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <PersonalStorageOptionsPage />
    </>
  )
}

export default Page
